'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectionList = function (_Component) {
  (0, _inherits3.default)(SelectionList, _Component);

  function SelectionList(props) {
    (0, _classCallCheck3.default)(this, SelectionList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectionList.__proto__ || (0, _getPrototypeOf2.default)(SelectionList)).call(this, props));

    _this.state = {
      available: _this.props.available,
      selected: _this.props.selected,
      hasSelected: _this.props.selected.length > 0
    };

    _this.isSelected = _this.isSelected.bind(_this);
    _this.hasSelected = _this.hasSelected.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    _this.defaultAction = _this.defaultAction.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SelectionList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var available = newProps.available,
          selected = newProps.selected;


      this.setState((0, _extends3.default)({}, this.state, {
        available: available,
        selected: selected
      }));
    }
  }, {
    key: 'isSelected',
    value: function isSelected(item) {
      return this.state.selected.indexOf(item) > -1 || this.state.selected.find(function (sel) {
        return sel.id && sel.id === item.id;
      }) !== undefined;
    }
  }, {
    key: 'hasSelected',
    value: function hasSelected() {
      return this.state.selected.length > 0;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(item) {
      return this.props.action.call(this, item);
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      return this.props.clear.call(this);
    }
  }, {
    key: 'defaultAction',
    value: function defaultAction(item) {
      return SelectionList.defaultAction.call(this, item);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var filters = this.state.available.map(function (item, i) {
        return _react2.default.createElement(
          'li',
          {
            className: item[_this2.props.customClassKey],
            key: item[_this2.props.idKey] || i,
            onClick: _this2.handleClick.bind(_this2, item)
          },
          _react2.default.createElement(_.SelectableLabel, {
            label: item[_this2.props.labelKey],
            group: item[_this2.props.groupKey],
            selected: _this2.isSelected(item),
            appearance: _this2.props.appearance,
            iconSelected: _this2.props.iconSelected,
            iconUnselected: _this2.props.iconUnselected
          })
        );
      });

      if (this.props.clearText && (!this.props.hideClearWhenEmpty || this.hasSelected())) {
        var clear = _react2.default.createElement(
          'li',
          { className: 'clear', key: 'clear', onClick: this.handleClear },
          _react2.default.createElement(_.SelectableLabel, {
            label: this.props.clearText,
            selected: !this.hasSelected(),
            iconSelected: this.props.iconSelected || 'checkmark',
            iconUnselected: this.props.iconUnselected || 'x'
          })
        );

        if (this.props.clearPosition === 'last') {
          filters.push(clear);
        } else {
          filters.unshift(clear);
        }
      }

      var layoutClassNames = (this.props.layout === 'grid' ? 'columns-' + this.props.columns : '') + ' ';
      var listClassNames = (this.hasSelected() ? 'selected' : '') + ' ' + this.props.layout;

      return _react2.default.createElement(
        'div',
        { className: '' + layoutClassNames },
        _react2.default.createElement(
          'ul',
          { className: 'SelectionList ' + this.props.customClassName + ' ' + listClassNames },
          filters
        )
      );
    }
  }]);
  return SelectionList;
}(_react.Component);

SelectionList.propTypes = {
  /**
   * Function with an item as its argument that is called on a click.
   */
  action: _propTypes2.default.func,
  /**
   * The appearance of SelectableLabels.
   */
  appearance: _propTypes2.default.oneOf(['plain', 'filter', 'tag']),
  /**
   * All available items.
   */
  available: _propTypes2.default.array.isRequired,
  /**
   * Function to clear the selection
   */
  clear: _propTypes2.default.func,
  /**
   * Whether to display the clear button first or last
   */
  clearPosition: _propTypes2.default.oneOf(['first', 'last']),
  /**
   * Text to display on the "Clear" or "Show all" item, the first of the list.
   */
  clearText: _propTypes2.default.string,
  /**
   * Number of grid columns when using the `grid` layout.
   */
  columns: _propTypes2.default.number,
  /**
   * Key in each item of available to use as as className.
   */
  customClassKey: _propTypes2.default.string,
  /**
   * Class name to apply to the SelectionList element.
   */
  customClassName: _propTypes2.default.string,
  /**
   * Key in each item of available to use as a group
   */
  groupKey: _propTypes2.default.string,
  /**
   * Whether to show the Clear button when there are no selected items.
   */
  hideClearWhenEmpty: _propTypes2.default.bool,
  /**
   * The name of the icon to pass to SelectionLabel for selected items.
   */
  iconSelected: _propTypes2.default.string,
  /**
   * The name of the icon to pass to SelectionLabel for unselected items.
   */
  iconUnselected: _propTypes2.default.string,
  /**
   * Key in each item of available to use as a key (unique identifier). Fallbacks on index.
   */
  idKey: _propTypes2.default.string,
  /**
   * Key in each item of available to use as a label
   */
  labelKey: _propTypes2.default.string,
  /**
   * Display labels as a linear list, an inline list, or a grid.
   */
  layout: _propTypes2.default.oneOf(['list', 'grid', 'inline', 'commaSeparated']),
  /**
   * Selected items.
   */
  selected: _propTypes2.default.array
};
SelectionList.defaultProps = {
  action: function action() {},
  appearance: 'filter',
  clear: function clear() {},
  clearPosition: 'first',
  clearText: '',
  columns: 2,
  customClassName: '',
  customClassKey: 'class',
  groupKey: 'group',
  idKey: 'id',
  labelKey: 'label',
  selected: [],
  layout: 'list'
};
exports.default = SelectionList;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SelectionList.js
// module id = 285
// module chunks = 0